var ExternalCustomEvents = {
    BCPageView: 'ViewContent',
    BCBuyBoxClick: 'Purchase',
};
function mapAppEventToExternalCustomEvent(eventType) {
    if (eventType === null || eventType === void 0 ? void 0 : eventType.endsWith('page view')) {
        return ExternalCustomEvents.BCPageView;
    }
    if (eventType === null || eventType === void 0 ? void 0 : eventType.endsWith('openRetailerProductPage')) {
        return ExternalCustomEvents.BCBuyBoxClick;
    }
    return undefined;
}
var timeoutPromise = function (ms, name, fn) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            reject(new Error("".concat(name, " timed out after ").concat(ms, "ms")));
        }, ms);
        fn().then(resolve, reject);
    });
};
function parseEventAndPayload(eventName, payload) {
    if ((payload === null || payload === void 0 ? void 0 : payload.sku) || (payload === null || payload === void 0 ? void 0 : payload.stacklineSku)) {
        return {
            eventName: mapAppEventToExternalCustomEvent(eventName),
            eventPayload: JSON.parse(JSON.stringify({
                stacklineSku: (payload === null || payload === void 0 ? void 0 : payload.sku) || (payload === null || payload === void 0 ? void 0 : payload.stacklineSku),
                retailerId: payload === null || payload === void 0 ? void 0 : payload.retailerId,
                retailerSku: payload === null || payload === void 0 ? void 0 : payload.retailerSku,
                retailPrice: payload === null || payload === void 0 ? void 0 : payload.retailPrice,
                jl_id: payload === null || payload === void 0 ? void 0 : payload.jl_id,
                jl_c: payload === null || payload === void 0 ? void 0 : payload.jl_c,
                jl_m: payload === null || payload === void 0 ? void 0 : payload.jl_m,
                jl_s: payload === null || payload === void 0 ? void 0 : payload.jl_s,
            })),
        };
    }
    return {
        eventName: undefined,
        eventPayload: {},
    };
}

export { ExternalCustomEvents, mapAppEventToExternalCustomEvent, parseEventAndPayload, timeoutPromise };
//# sourceMappingURL=utils.js.map
